module.exports = __webpack_public_path__ + "static/media/call_key_icon.0bdde35b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallWindow/call_key_icon.svg
// module id = 1748
// module chunks = 0